import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Share of Voice Dashboard page */
export default class DashboardOnBoarding extends React.Component {
  static propTypes = {
    run: PropTypes.bool.isRequired,
    setScroll: PropTypes.func.isRequired,
    category: PropTypes.string
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback={evt => {
          if (evt.index === 2)
            this.props.setScroll()
          }
        }
        />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Share of Conversation Dashboard!<br /><br />This dashboard provides the percent share for a distribution channel, network, platform, or content title within the entire landscape of media and entertainment engagement.<br /></p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>At the top of the page, high level categories are displayed along with their associated performance statistics. Click on the dropdown to switch categories or click on the tile to filter the titles in the leaderboard panel to the right.</p>),
        target: '#networkSelect'
      },
      {
        ...common,
        content: (<p>Navigate to different points on the graph using the date selector tool in the top left corner. Alternatively, click directly on a day by mousing over the lines on the graph and selecting the pop-up node. </p>),
        target: '#dateSelect'
      },
      {
        ...common,
        content: (<p>The main graph displays a rolling 30-day view of Share of Conversation performance; you can alternate between a trendline or stacked bar chart view using the graph type icons.</p>),
        target: '#sovNetworksChart'
      },
      {
        ...common,
        content: (<p>The Content Rank leaderboard panel lists titles by share of engagement. This list is color-coded based on category, and can be filtered by clicking on the category tiles at the top of the graph.<br/><br/>Let's Go!</p>),
        target: '#contentRank'
      }
    ]

    return steps
  }
}
